import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TooltipModule } from '@libs/ui-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { NsStatus } from '../prescriptions-item/prescriptions-item.component';

@Component({
  selector: 'lib-prescriptions-ns-icon',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, TooltipModule, TranslatePipe],
  templateUrl: './prescriptions-ns-icon.component.html',
  styleUrl: './prescriptions-ns-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionsNsIconComponent {
  public readonly status = input.required<NsStatus>();
}
